<template>
    <b-table striped hover :items="items"></b-table>
</template>

<script>
export default {
    data() {
        return {
            items: []
        }
    },
    mounted () {
        let result = []
        const label = this.$attrs["options"].columnLabelName
        const value = this.$attrs["options"].columnValueName
        for (let row of this.$attrs["chart-data"]){
            const item = {};
            row = row.split(' - ');
            item[label] = row[0];
            item[value] = row[1];
            result.push(item)
        }
        this.items = result;
    }
}
</script>